<template>
  <div>
    <table-layout
      pkField="output_id"
      :selected.sync="selected"
      :isAdmin="isAdmin"
      :loading="serversLoading"
      :items="outputs"
      :columns="columns"
      :addOptions="outputsTypes"
      @click:addNew="addOutput"
    >
      <template #actions>
        <b-dropdown-item @click="testOutputs" aria-role="listitem">{{ $t('lists.test') }}</b-dropdown-item>
        <b-dropdown-item @click="openDialogRemove" aria-role="listitem">{{ $t('lists.deleteDetail') }}</b-dropdown-item>
      </template>
    </table-layout>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import TableLayout from '@/layout/TableLayout'

const { mapState: mapUserState } = createNamespacedHelpers('general')

export default {
  name: 'Outputs',
  components: {
    TableLayout
  },
  created() {
    this.refetch()
    this.getTypes()
  },
  computed: {
    ...mapUserState({
      role: state => state.user.role
    }),
    isAdmin() {
      return this.role === 'ADMIN'
    }
  },
  data() {
    return {
      outputs: [],
      serversLoading: false,
      outputsTypes: [],
      columns: [
        {
          sortable: true,
          field: 'name',
          label: 'columns.name',
          route: {
            name: 'output',
            params: [
              {
                name: 'output_id',
                field: 'output_id'
              }
            ]
          }
        },
        {
          sortable: true,
          field: 'type',
          label: 'columns.output.type'
        },
        {
          loadable: true,
          sortable: true,
          field: 'last_status',
          label: 'columns.status'
        },
        {
          sortable: true,
          field: 'description',
          label: 'columns.description',
          bindHtml: true
        }
      ],
      selected: []
    }
  },
  methods: {
    ...mapActions('general', ['setServerName']),
    addOutput(type) {
      this.$router.push({
        name: 'add_output',
        query: { type: type },
        params: {
          server_id: this.$route.params.server_id
        }
      })
    },
    refetch() {
      if (!this.serversLoading) {
        const body = {
          server_id: this.$route.params.server_id
        }
        const searchParams = new URLSearchParams(body)
        const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/outputs?${searchParams}`
        this.serversLoading = true
        fetch(url, {
          method: 'GET',
          credentials: 'include'
        })
          .then(res => {
            if (!res.ok) {
              throw res.json()
            }
            return res.json()
          })
          .then(data => {
            this.outputs = data.outputs
            this.setServerName(data.server_name)
          })
          .catch(error =>
            error.then(data => {
              this.$notify({
                message: JSON.parse(data.message).message,
                type: 'danger'
              })
            })
          )
          .finally(() => {
            this.serversLoading = false
          })
      }
    },
    getTypes() {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/outputs/types`
      fetch(url, {
        method: 'GET',
        credentials: 'include'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(data => {
          this.outputsTypes = data
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
    },
    test(output_ids) {
      const index_output_ids = this.outputs.findIndex(obj => {
        return obj.output_id == output_ids
      })
      if (index_output_ids >= 0) {
        this.outputs[index_output_ids].loading = true
        this.outputs[index_output_ids].last_status = 'loading'
      }
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/outputs/test`
      return fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          server_id: this.$route.params.server_id,
          output_ids: output_ids
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(status => {
          for (const [key, value] of Object.entries(status)) {
            const index = this.outputs.findIndex(obj => {
              return obj.output_id == key
            })
            if (index >= 0) {
              this.outputs[index].last_status = value
              this.outputs[index].loading = false
            }
          }
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
    },
    testOutputs() {
      if (!this.selected.length) {
        this.$notify({
          message: this.$t('notification.unselected'),
          type: 'danger'
        })
        return
      }
      for (let i = 0; i < this.selected.length; ++i) {
        this.test([this.selected[i]])
      }
    },
    deleteOutputs(output_ids) {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/outputs/delete`
      return fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          server_id: this.$route.params.server_id,
          output_ids: output_ids
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(() => {
          const indexSet = new Set(output_ids)
          this.outputs = this.outputs.filter(value => {
            return !indexSet.has(value.output_id)
          })
          this.selected = []
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
    },
    openDialogRemove() {
      if (!this.selected.length) {
        this.$notify({
          message: this.$t('notification.unselected'),
          type: 'danger'
        })
        return
      }
      const indexSet = new Set(this.selected)
      const outputs = this.outputs
        .filter(value => {
          return indexSet.has(value.output_id)
        })
        .map(d => {
          return d['name']
        })
      const msg = outputs
        .map(d => {
          return d
        })
        .join(', ')

      this.$dialog.confirm({
        message: `${this.$t('confirm.remove', {
          msg: msg
        })}?`,
        onConfirm: () => {
          this.serversLoading = true
          this.deleteOutputs(this.selected)
            .then(() => {
              this.$notify({
                message: this.$t('notification.removed', {
                  msg: msg
                }),
                type: 'success'
              })
            })
            .finally(() => (this.serversLoading = false))
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.table {
  width: 100%;
}
</style>
